import React, { ReactNode } from 'react';

import moverWithCart from '@images/illustrations/mover_with_cart_and_boxes.svg';
import moversWithTV from '@images/illustrations/movers_with_tv_small.svg';
import storageFacility from '@images/illustrations/storage_facility.svg';
import wrappedPackedItems from '@images/illustrations/wrapped_packed_items.svg';

import { InfoCardItem } from './info_card_item';
import { InfoCardList } from './info_card_list';

type HowClutterMovingWorksEntry = {
  title: ReactNode;
  subtitle: ReactNode;
  icon: string;
};

const ENTRIES: HowClutterMovingWorksEntry[] = [
  {
    title: 'Packing & Unloading',
    subtitle: (
      <>We’ll safely pack your items and unload them into the rooms you want.</>
    ),
    icon: wrappedPackedItems,
  },
  {
    title: 'Furniture Assembly',
    subtitle: (
      <>
        We’ll take down TVs and take apart and put back together certain
        furniture.
      </>
    ),
    icon: moversWithTV,
  },
  {
    title: 'Item Disposal',
    subtitle: <>We’ll pick up items you no longer want during your move.</>,
    icon: moverWithCart,
  },
  {
    title: 'Monthly Storage',
    subtitle: (
      <>
        We’ll pack and transport the items you need stored in our facilities
        during your move.
      </>
    ),
    icon: storageFacility,
  },
];

export const HowClutterMovingWorks = () => (
  <InfoCardList title="How Clutter Makes Moving Convenient">
    {ENTRIES.map((entry, key) => (
      <InfoCardItem {...entry} key={key} />
    ))}
  </InfoCardList>
);
